import Text from '@components/Text';
import colors from '@constants/colors';

import styles from './styles.module.scss';

function OrderNote() {
  return (
        <div className={styles.container}>
            <Text color={colors.gray6} className={styles.text}>
                보유하신 모바일 기기 내 앱 PUSH 알림을 켜두시면<br/>
                보다 빠르게 실시간 주문 상태를 보실 수 있습니다.
            </Text>
        </div>
  );
}

export default OrderNote;
